import { render, staticRenderFns } from "./ProspectSearchLayout.vue?vue&type=template&id=623c5962"
import script from "./ProspectSearchLayout.vue?vue&type=script&lang=js"
export * from "./ProspectSearchLayout.vue?vue&type=script&lang=js"
import style0 from "./ProspectSearchLayout.vue?vue&type=style&index=0&id=623c5962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports